// Every module's manifest, and the install step each runtime runs once at startup.
import { registerModuleAccess, registerModuleEvents } from "@vavr/core";
import type { ModuleManifest } from "./define.ts";
import { calendar } from "./calendar/manifest.ts";
import { lostfound } from "./lostfound/manifest.ts";
import { messages } from "./messages/manifest.ts";
import { radio } from "./radio/manifest.ts";
import { transport } from "./transport/manifest.ts";
import { emergency } from "./emergency/manifest.ts";

export { defineModule, type ModuleManifest } from "./define.ts";

export const MODULES: readonly ModuleManifest[] = [radio, transport, messages, lostfound, calendar, emergency];

let installed = false;
/** Adds every module's roles, permissions and event types to the core tables. Safe to call more than once. */
export function installModules() {
  if (installed) return;
  installed = true;
  for (const m of MODULES) {
    for (const r of m.roles ?? []) if (!r.id.startsWith(`${m.id}:`)) throw new Error(`module ${m.id}: role ${r.id} is not namespaced`);
    for (const p of Object.keys(m.grants ?? {})) if (!p.startsWith(`${m.id}:`)) throw new Error(`module ${m.id}: permission ${p} is not namespaced`);
    for (const e of m.events ?? []) if (!e.type.startsWith(`${m.id}:`)) throw new Error(`module ${m.id}: event ${e.type} is not namespaced`);
    registerModuleAccess(m);
    registerModuleEvents(m.events ?? []);
  }
}
